import html2plaintext from "html2plaintext";
import replace from "lodash/replace";

export default function htmlToCleanText(text) {
  const cleanText = html2plaintext(text || "");
  const replacedText = replace(cleanText, /[\n\r]/g, " ");
  return replacedText;
}
